$(document).on("turbo:load", function () {
  $(".div-to-animate").addClass("animated fadeIn");
});
